import React from 'react';
import PropTypes from 'prop-types';
import { i18nMark } from 'lingui-react';

import { Link } from 'base-components';

const ariaLabel = i18nMark('Open case detail');

export default function CaseLink({ caseNumber, ...rest }) {
  return (
    <Link aria-label={ariaLabel} {...rest} to={`/cases/${caseNumber}`}>
      {caseNumber}
    </Link>
  );
}

CaseLink.propTypes = {
  caseNumber: PropTypes.string.isRequired,
};

CaseLink.displayName = 'CaseLink';



// WEBPACK FOOTER //
// ./src/elements/CaseLink/index.js